<template>
  <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header">{{title}} {{$t('tax_type')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'tax_name'"
          v-bind="textFieldConfig"
          :value="tax_type.tax_name"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'tax_description'"
          v-bind="textFieldConfig"
          :value="tax_type.tax_description"
          :placeholder="$t('subject')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <v-layout row wrap>
          <v-flex md6 pr-1>
            <TextField
              class="m1"
              :id="'tax_rate_percent'"
              v-bind="textFieldConfig"
              :value="tax_type.tax_rate_percent"
              :placeholder="$t('tax_rate')"
              @valuechanged="onTextFieldValueChange"
            ></TextField>
          </v-flex>
          <v-flex md6>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="'tax_deduction_flag'"
                  :id="'tax_deduction_flag'"
                  :checked="tax_type.tax_deduction_flag=='1'"
                  @click="e => onCheckboxChange('tax_deduction_flag', e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('tax_deduction_text')}}</div>
            </div>
          </v-flex>
        </v-layout>
        <Dropdown
          :options="vat_types"
          class="m2"
          :selected="vat_types.find(e => e.value == tax_type.vat_type)"
          :placeholder="$t('vat_type_string')"
          v-on:selectedChange="e => onDropdownChange('vat_type', e)"
          :listHeight="95"
          box
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onFormSubmit">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { createFormModalMixin, createFormItemMixin } from "../../../../dt-plugins/form-modal/form-modal";
import { AccountingSettingsService } from "../../services/accounting-settings.service";
import { getVatTypes } from '../../models/invoice-line.model';

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      vat_types: getVatTypes(),
    };
  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "tax_type_id",
      itemKey: "tax_type",
      detailsHttpReq: AccountingSettingsService.findTaxTypeDetails,
    })
  ],
  methods: {
    get_tax_type: function() {
      return {
        tax_rate_percent: null,
        target_country: null,
        created: null,
        last_modified: null,
        vat_type: null,
        tax_deduction_flag: null,
        tax_name: null,
        tax_type_id: null,
        tax_description: null
      };
    },
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-money-details-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
